import { gql } from "@apollo/client";

export const BATCH_UPLOAD = gql`
	mutation ($agents: [BatchUploadObject]) {
		batchUpload(agents: $agents) {
			partnerAgent {
				partnerAgentId
			}
		}
	}
`;
